import getCbtClient, { cbtResponse } from "../cbtClient";
import { CbtConnectionData } from "../cbtConnectionData";

interface ApprovalConfigurationRequestBody {
  PolicyResolveId: string;
}

interface ApprovalConfigurationResponseData {
  Type: "Guest" | "Traveller";
  TravellerId: string;
  TravellerEmail: string;
  ApprovalConfigurations:
    | "MANAGER_COST_CENTER"
    | "MANAGER_TRAVELLER"
    | "MANAGERS_GROUPS"
    | "MANAGER_SELECTED_DURING_BOOKING"
    | "MANAGER_DEFINED";
  ShouldDisplaySelector: boolean;
  IndividualSelector: boolean;
}

interface ApprovalConfigurationParams {
  cbtConnectionData: CbtConnectionData;
  policyResolveId: string;
}

const approvalConfigurationPath = "/reservations/approval-configuration";

const approvalConfiguration = async ({
  cbtConnectionData,
  policyResolveId,
}: ApprovalConfigurationParams): Promise<
  ApprovalConfigurationResponseData[]
> => {
  const body: ApprovalConfigurationRequestBody = {
    PolicyResolveId: policyResolveId,
  };

  const cbtClient = await getCbtClient(cbtConnectionData);

  const response = await cbtResponse(
    cbtClient.post(approvalConfigurationPath, body)
  );

  const data: ApprovalConfigurationResponseData[] = response.success
    ? response.data?.data
    : [];

  return data;
};

export default approvalConfiguration;
